var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGDriveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 23,
    viewBox: "0 0 40.173 35.904",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3659",
    "data-name": "Group 3659",
    transform: "translate(-334.001 -542.048)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4530",
    "data-name": "Path 4530",
    d: "M-3390.944-1393.615a1.5,1.5,0,0,0,.1-.458,4.1,4.1,0,0,1,.466-1.275q1.819-3.159,3.641-6.317l3.871-6.71q2.1-3.635,4.195-7.27a4,4,0,0,1,1.449-1.461c.133-.058.187.031.242.126.347.594.689,1.19,1.032,1.786q1.583,2.748,3.171,5.494.93,1.612,1.863,3.223a.78.78,0,0,1,.108.292,3.772,3.772,0,0,1-.495.957c-.643,1.136-1.3,2.264-1.952,3.395q-.939,1.628-1.878,3.255-.968,1.682-1.937,3.363c-.34.591-.675,1.185-1.024,1.771a.415.415,0,0,1-.167.2l-.062.007a1.688,1.688,0,0,1-.349.027q-5.938,0-11.875,0c-.135,0-.284.041-.4-.082Z",
    transform: "translate(3724.945 1959.751)",
    fill: "#00ac47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4531",
    "data-name": "Path 4531",
    d: "M-3390.944-56.232c.087,0,.175,0,.262,0h12.133c.093,0,.186,0,.28.006.057.093,0,.17-.04.244q-.665,1.149-1.327,2.3-.9,1.559-1.8,3.117-.719,1.249-1.441,2.5c-.506.871-1,1.746-1.511,2.616a.646.646,0,0,1-.177.211c-.117.03-.2-.043-.286-.1a4.3,4.3,0,0,1-1.313-1.381q-1.231-2.114-2.45-4.234-.9-1.566-1.809-3.132a3.474,3.474,0,0,1-.5-1.757.086.086,0,0,0-.018-.065Z",
    transform: "translate(3724.945 622.683)",
    fill: "#0066da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4532",
    "data-name": "Path 4532",
    d: "M-1807.075-60.958a.07.07,0,0,1,.03.011v.315c-.031.235-.024.473-.057.708a3.28,3.28,0,0,1-.461,1.162c-.724,1.27-1.458,2.535-2.191,3.8-.721,1.245-1.417,2.506-2.176,3.728a3.985,3.985,0,0,1-1.152,1.156.347.347,0,0,1-.3.1.493.493,0,0,1-.2-.238q-1.135-1.966-2.27-3.933-.992-1.716-1.985-3.432c-.611-1.052-1.213-2.109-1.825-3.161-.055-.1-.094-.2.039-.268a1.631,1.631,0,0,1,.349-.02q5.9,0,11.8,0C-1807.341-61.03-1807.195-61.062-1807.075-60.958Z",
    transform: "translate(2181.219 627.399)",
    fill: "#ea4335"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4533",
    "data-name": "Path 4533",
    d: "M-2222.8-1394.147c-.093,0-.186.006-.28.006h-12.163l-.157,0h-.026a.28.28,0,0,1-.162-.149c-.438-.75-.867-1.505-1.3-2.257q-.765-1.325-1.529-2.651-.9-1.562-1.8-3.122-.746-1.295-1.5-2.589c-.36-.62-.711-1.245-1.075-1.862a.428.428,0,0,1-.052-.252.54.54,0,0,1,.121-.389l3.012-5.219q1.48-2.564,2.963-5.126c.052-.091.084-.213.222-.223a.513.513,0,0,1,.168.09,4.188,4.188,0,0,1,1.373,1.444q4.879,8.474,9.76,16.946c.611,1.061,1.217,2.125,1.831,3.184a4.389,4.389,0,0,1,.571,1.622A5.078,5.078,0,0,1-2222.8-1394.147Z",
    transform: "translate(2596.947 1960.587)",
    fill: "#ffba00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4534",
    "data-name": "Path 4534",
    d: "M-2594.469-1449.568l-3.217,5.575-3.025,5.242c-.026.045-.047.094-.07.14l-.015.006c-.164-.289-.326-.578-.491-.866q-.518-.9-1.039-1.8-.827-1.43-1.654-2.86-.8-1.385-1.6-2.771-.721-1.249-1.441-2.5c-.036-.062-.072-.121-.151-.131a4.037,4.037,0,0,1,1.38-.523,3.9,3.9,0,0,1,.764-.073h8.5a4.028,4.028,0,0,1,1.9.459A.506.506,0,0,1-2594.469-1449.568Z",
    transform: "translate(2954.891 1992.179)",
    fill: "#00832d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4535",
    "data-name": "Path 4535",
    d: "M-2999.643-49.887a3.949,3.949,0,0,1-1.233.473,4.562,4.562,0,0,1-1.008.088h-10.022q-6.507,0-13.013,0a4.43,4.43,0,0,1-1.628-.267,2.755,2.755,0,0,1-.579-.285c.219-.384.437-.769.658-1.153q.64-1.114,1.281-2.226.529-.916,1.059-1.83.646-1.12,1.291-2.241.515-.893,1.032-1.785.493-.855.984-1.712a.066.066,0,0,0,.013-.013.537.537,0,0,1,.3-.074c.052,0,.1,0,.157,0h13.919a.805.805,0,0,1,.459.074.048.048,0,0,0,.018.008c.318.556.635,1.112.955,1.667Q-3002.321-54.524-2999.643-49.887Z",
    transform: "translate(3367.496 627.278)",
    fill: "#2684fc"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGDriveIcon);
export default __webpack_public_path__ + "static/media/GDriveIcon.de2d983aa7169a7c7eaf905d6dae730c.svg";
export { ForwardRef as ReactComponent };